<template>
  <div class="repayment_page">
    <van-nav-bar :title="$t('q80')" class="header_b">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px"
        />
      </template>
    </van-nav-bar>
    <div class="content_re">
      <div class="tabs">
        <div
          :class="['tab_item', { active: activeTab === 'all' }]"
          @click="activeTab = 'all'"
        >
          {{ $t("q81") }}
        </div>
        <div
          :class="['tab_item', { active: activeTab === 'pending' }]"
          @click="activeTab = 'pending'"
        >
          {{ $t("q82") }}
        </div>
        <div
          :class="['tab_item', { active: activeTab === 'completed' }]"
          @click="activeTab = 'completed'"
        >
          {{ $t("q83") }}
        </div>
      </div>

      <div class="list_container">
        <div v-for="item in filteredList" :key="item.id" class="loan_card">
          <div class="card_header">
            <div class="card_title">
              <span class="icon"></span>
              <span>{{ $t("q84") }} #{{ item.id }}</span>
            </div>
            <div :class="['status_tag', 'status-' + item.state_code]">
              {{ $t(item.state_desc) }}
            </div>
          </div>

          <div class="card_body">
            <div class="info_row">
              <div class="info_label">{{ $t("q85") }}</div>
              <div class="info_value">{{ item.user_name }}</div>
            </div>
            <div class="info_row">
              <div class="info_label">{{ $t("q86") }}</div>
              <div class="info_value">{{ item.quota }}</div>
            </div>
            <div class="info_row">
              <div class="info_label">{{ $t("q87") }}</div>
              <div class="info_value">{{ item.term }} {{ $t("q105") }}</div>
            </div>
            <div class="info_row">
              <div class="info_label">{{ $t("q88") }}</div>
              <div class="info_value">
                {{ (parseFloat(item.daily_rate) * 100).toFixed(4) }}%
              </div>
            </div>
            <div class="info_row">
              <div class="info_label">{{ $t("q89") }}</div>
              <div class="info_value">{{ item.total_interest }}</div>
            </div>
            <div class="info_row">
              <div class="info_label">{{ $t("q90") }}</div>
              <div class="info_value">{{ item.total_amount }}</div>
            </div>
            <div class="info_row">
              <div class="info_label">{{ $t("q91") }}</div>
              <div class="info_value">{{ item.create_time }}</div>
            </div>
            <div class="info_row">
              <div class="info_label">{{ $t("q92") }}</div>
              <div class="info_value">{{ item.expire_date }}</div>
            </div>
            <div v-if="item.reason" class="info_row warning">
              <div class="info_label">{{ $t("q93") }}</div>
              <div class="info_value">{{ item.reason }}</div>
            </div>
          </div>

          <div class="card_footer">
            <div class="amount_summary">
              <span class="summary_label">{{ $t("q94") }}</span>
              <span class="summary_value"
                >{{ item.symbol }} {{ item.total_amount }}</span
              >
            </div>
            <button
              v-if="item.state_code === 2"
              class="repay_btn"
              @click="showRepayModal(item)"
            >
              {{ $t("q95") }}
            </button>
            <div v-else :class="['status_text', 'status-' + item.state_code]">
              {{ $t(item.state_desc) }}
            </div>
          </div>
        </div>

        <van-empty
          v-if="filteredList.length === 0"
          :description="$t('暂无记录')"
        />
      </div>
    </div>

    <van-dialog
      v-model="showModal"
      :title="$t('q96')"
      :show-cancel-button="true"
      :cancel-button-text="$t('q97')"
      :confirm-button-text="$t('q98')"
      @confirm="confirmRepay"
    >
      <div class="modal_content" v-if="currentLoan">
        <div class="modal_info">
          <div class="modal_row">
            <span class="modal_label">{{ $t("q84") }}:</span>
            <span class="modal_value">#{{ currentLoan.id }}</span>
          </div>
          <div class="modal_row">
            <span class="modal_label">{{ $t("q86") }}:</span>
            <span class="modal_value"> {{ currentLoan.quota }}</span>
          </div>
          <div class="modal_row">
            <span class="modal_label">{{ $t("q89") }}:</span>
            <span class="modal_value">{{ currentLoan.total_interest }}</span>
          </div>
          <div class="modal_row total">
            <span class="modal_label">{{ $t("q90") }}:</span>
            <span class="modal_value">{{ currentLoan.total_amount }}</span>
          </div>
        </div>
        <div class="modal_tip">
          {{ $t("q99") }}
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: "all",
      showModal: false,
      currentLoan: null,
      loanList: [],
    };
  },
  computed: {
    filteredList() {
      if (this.activeTab === "all") {
        return this.loanList;
      } else if (this.activeTab === "pending") {
        return this.loanList.filter((item) => item.state_code === 2);
      } else if (this.activeTab === "completed") {
        return this.loanList.filter((item) => item.state_code === 4);
      }
      return this.loanList;
    },
  },
  methods: {
    back() {
      return window.history.back();
    },
    showRepayModal() {
      // this.currentLoan = item;
      // this.showModal = true;
      this.$router.push({ path: "/ServiceOnline" });
    },
    confirmRepay() {
      this.$http({
        method: "post",
        url: "loanRepay",
        data: {
          id: this.currentLoan.id,
          amount: this.currentLoan.total_amount,
          user_id: this.$route.query.user_id,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.showModal = false;
          this.$toast.success(this.$t("q100"));
          this.getLoanFn();
        }
      });
    },
    // 查询贷款列表
    getLoanFn() {
      this.$http({
        method: "get",
        url: "getLoan",
        data: {
          user_id: this.$route.query.user_id,
        },
      }).then((res) => {
        this.loanList = res.data;
      });
    },
  },
  created() {
    this.getLoanFn();
  },
};
</script>

<style scoped lang="less">
.repayment_page {
  position: relative;
  background-color: #101012;
  min-height: 100vh;
  padding-top: 100px;
  box-sizing: border-box;

  .content_re {
    position: relative;
    padding: 20px;
    padding-bottom: 60px;
  }

  .header_b {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }

  .tabs {
    display: flex;
    background: linear-gradient(120deg, #212121, #313131);
    border: 1px solid #766350;
    border-radius: 16px;
    padding: 10px;
    margin-bottom: 20px;

    .tab_item {
      flex: 1;
      text-align: center;
      padding: 20px;
      color: #999;
      font-size: 26px;
      border-radius: 12px;
      transition: all 0.3s ease;

      &.active {
        background: linear-gradient(90deg, #efcba7, #dcab76);
        color: #1a1a1a;
        font-weight: bold;
      }
    }
  }

  .list_container {
    .loan_card {
      background: linear-gradient(120deg, #212121, #313131);
      border: 1px solid #766350;
      border-radius: 16px;
      margin-bottom: 20px;
      overflow: hidden;

      .card_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        border-bottom: 1px solid #333;

        .card_title {
          display: flex;
          align-items: center;
          color: #e6b98a;
          font-size: 28px;
          font-weight: bold;

          .icon {
            width: 8px;
            height: 30px;
            background-color: #e6b98a;
            border-radius: 4px;
            margin-right: 12px;
          }
        }

        .status_tag {
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 22px;
          &.status-1 {
            background-color: rgba(25, 137, 250, 0.2);
            color: #1989fa;
          }
          &.status-2 {
            background-color: rgba(255, 193, 7, 0.2);
            color: #ffc107;
          }

          &.status-3 {
            background-color: rgba(255, 87, 34, 0.2);
            color: #ff5722;
          }

          &.status-4 {
            background-color: rgba(76, 175, 80, 0.2);
            color: #4caf50;
          }
        }
      }

      .card_body {
        padding: 20px;

        .info_row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 0;
          border-bottom: 1px solid #2a2a2a;

          &:last-child {
            border-bottom: none;
          }

          &.warning {
            .info_value {
              color: #ff5722;
            }
          }

          .info_label {
            font-size: 24px;
            color: #999;
          }

          .info_value {
            font-size: 24px;
            color: #fff;
          }
        }
      }

      .card_footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        background-color: rgba(0, 0, 0, 0.3);

        .amount_summary {
          display: flex;
          flex-direction: column;

          .summary_label {
            font-size: 22px;
            color: #666;
          }

          .summary_value {
            font-size: 32px;
            font-weight: bold;
            color: #e6b98a;
          }
        }

        .repay_btn {
          padding: 16px 40px;
          background: linear-gradient(90deg, #efcba7, #dcab76);
          border: none;
          border-radius: 12px;
          color: #1a1a1a;
          font-size: 26px;
          font-weight: bold;
          transition: all 0.3s ease;

          &:active {
            opacity: 0.8;
          }
        }

        .status_text {
          font-size: 26px;
          &.status-1 {
            color: #1989fa;
          }
          &.status-2 {
            color: #ffc107;
          }

          &.status-3 {
            color: #ff5722;
          }

          &.status-4 {
            color: #4caf50;
          }
        }
      }
    }
  }
  ::v-deep(.van-dialog) {
    width: 90%;
  }
  ::v-deep(.van-dialog__header) {
    font-size: 32px;
  }
  .modal_content {
    width: 100%;
    margin: 0 auto;
    padding: 20px 32px;
    box-sizing: border-box;

    .modal_info {
      width: 100%;

      .modal_row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px 0;
        border-bottom: 1px solid #eee;

        &.total {
          border-bottom: none;
          padding-top: 20px;

          .modal_value {
            color: #e6b98a;
            font-size: 48px;
            font-weight: bold;
          }
        }

        .modal_label {
          font-size: 28px;
          color: #666;
          flex-shrink: 0;
        }

        .modal_value {
          font-size: 28px;
          color: #333;
          text-align: right;
          flex: 1;
          margin-left: 15px;
          word-break: break-all;
        }
      }
    }

    .modal_tip {
      margin-top: 15px;
      padding: 24px;
      background-color: rgba(230, 185, 138, 0.1);
      border-radius: 6px;
      font-size: 24px;
      color: #999;
      line-height: 1.5;
    }
  }
  ::v-deep(.van-dialog__footer) {
    padding: 36px 0;
    .van-button {
      font-size: 36px;
    }
  }
}

.van-nav-bar {
  background-color: #1c1c1c;
}

@media screen and (min-width: 431px) {
  .repayment_page {
    max-width: 430px;
    width: calc(100% - 20px);
    margin: 20px auto;
    padding-top: 0;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(255, 255, 255, 0.05);
    min-height: calc(100vh - 60px);

    .header_b {
      position: sticky !important;
      top: 0;
    }

    .content_re {
      padding: 15px;
      padding-bottom: 40px;
    }

    .tabs {
      padding: 5px;
      margin-bottom: 15px;

      .tab_item {
        padding: 12px;
        font-size: 14px;
      }
    }

    .list_container {
      .loan_card {
        margin-bottom: 12px;

        .card_header {
          padding: 12px;

          .card_title {
            font-size: 16px;

            .icon {
              height: 20px;
            }
          }

          .status_tag {
            padding: 4px 12px;
            font-size: 12px;
          }
        }

        .card_body {
          padding: 12px;

          .info_row {
            padding: 6px 0;

            .info_label {
              font-size: 12px;
            }

            .info_value {
              font-size: 12px;
            }
          }
        }

        .card_footer {
          padding: 12px;

          .amount_summary {
            .summary_label {
              font-size: 11px;
            }

            .summary_value {
              font-size: 18px;
            }
          }

          .repay_btn {
            padding: 8px 20px;
            font-size: 14px;
          }

          .status_text {
            font-size: 14px;
          }
        }
      }
    }

    ::v-deep .van-nav-bar__content {
      height: 44px;
    }

    ::v-deep .van-nav-bar__title {
      font-size: 14px;
    }
    ::v-deep(.van-dialog) {
      width: 400px !important;
    }
    ::v-deep(.van-dialog__header) {
      font-size: 16px;
      padding: 10px 0;
    }
    .modal_content {
      width: 100%;
      margin: 0 auto;
      padding: 10px 16px;

      .modal_info {
        width: 100%;

        .modal_row {
          padding: 12px 0;

          &.total {
            border-bottom: none;
            padding-top: 10px;

            .modal_value {
              font-size: 24px;
            }
          }

          .modal_label {
            font-size: 14px;
            color: #666;
            flex-shrink: 0;
          }

          .modal_value {
            font-size: 14px;
            color: #333;
            text-align: right;
            flex: 1;
            margin-left: 15px;
            word-break: break-all;
          }
        }
      }

      .modal_tip {
        margin-top: 15px;
        padding: 12px;

        border-radius: 6px;
        font-size: 12px;
      }
    }
    ::v-deep(.van-dialog__footer) {
      padding: 12px 0;
      .van-button {
        font-size: 18px;
      }
    }
  }
}
</style>
